import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'

declare module 'dayjs' {
  interface Dayjs {
    businessDays(count: number): dayjs.Dayjs
  }
}

dayjs.prototype.businessDays = function (
  this: dayjs.Dayjs,
  count: number,
): dayjs.Dayjs {
  let day = this.clone()
  while (count > 0) {
    day = day.add(1, 'day')
    if (day.day() !== 0 && day.day() !== 6) count--
  }
  return day
}
dayjs.extend(advancedFormat)

const DATE_FORMAT = 'MM/DD/YYYY'
const [BUSINESS_DAYS_START, BUSINESS_DAYS_END] = [15, 20]
const TODAY = dayjs()

const getBusinessDay = (businessDays: number) => {
  return TODAY.businessDays(businessDays).format(DATE_FORMAT)
}

const getDeliveryDaysRange = (): string[] => {
  return [
    getBusinessDay(BUSINESS_DAYS_START),
    getBusinessDay(BUSINESS_DAYS_END),
  ]
}

const getStartDate = (monthsPrevious: number, dateFormat: string = 'YYYY-MM-DD') => {
  return dayjs().subtract(monthsPrevious, 'month').format(dateFormat)
}

const getCurrentDate = (dateFormat = 'YYYY-MM-DD') => {
  return dayjs().format(dateFormat)
}

const getDateByFormat = (
  date: string | number | Date | dayjs.Dayjs,
  dateFormat = 'MMMM Do, YYYY',
) => {
  return dayjs(date).format(dateFormat)
}

export { getDeliveryDaysRange, getStartDate, getCurrentDate, getDateByFormat }
